import angular from 'angular'

import StrictObj from '../utils/strict-obj'
import debugFields from '../utils/debug-fields'

import { intabbr, intcomma } from 'numeral-light'

import localeAr from 'numeral-light/locales/ar'
import localeBg from 'numeral-light/locales/bg'
import localeCs from 'numeral-light/locales/cs-CZ'
import localeDa from 'numeral-light/locales/da-DK'
import localeDe from 'numeral-light/locales/de-DE'
import localeEl from 'numeral-light/locales/el'
import localeEn from 'numeral-light/locales/en-US'
import localeEs from 'numeral-light/locales/es-ES'
import localeFa from 'numeral-light/locales/fa-IR'
import localeFi from 'numeral-light/locales/fi-FI'
import localeFr from 'numeral-light/locales/fr-FR'
import localeHe from 'numeral-light/locales/he-IL'
import localeId from 'numeral-light/locales/id'
import localeIt from 'numeral-light/locales/it-IT'
import localeJa from 'numeral-light/locales/ja-JP'
import localeKo from 'numeral-light/locales/ko-KR'
import localeNb from 'numeral-light/locales/nb'
import localeNl from 'numeral-light/locales/nl-NL'
import localePlPL from 'numeral-light/locales/pl-PL'
import localePtBR from 'numeral-light/locales/pt-BR'
import localePtPT from 'numeral-light/locales/pt-PT'
import localeRo from 'numeral-light/locales/ro-RO'
import localeRu from 'numeral-light/locales/ru-RU'
import localeUk from 'numeral-light/locales/uk-UA'
import localeSv from 'numeral-light/locales/sv-SE'
import localeTr from 'numeral-light/locales/tr-TR'
import localeVi from 'numeral-light/locales/vi'
import localeZhCN from 'numeral-light/locales/zh-CN'
import localeZhTW from 'numeral-light/locales/zh-TW'

const DEFAULT_LOCALE = localeEn

const LOCALES = StrictObj({
  ar: localeAr,
  bg: localeBg,
  cs: localeCs,
  da: localeDa,
  de: localeDe,
  el: localeEl,
  en: localeEn,
  es: localeEs,
  fa: localeFa,
  fi: localeFi,
  fr: localeFr,
  he: localeHe,
  hi: DEFAULT_LOCALE,
  id: localeId,
  it: localeIt,
  ja: localeJa,
  ko: localeKo,
  nb: localeNb,
  nl: localeNl,
  pl: localePlPL,
  'pt-BR': localePtBR,
  'pt-PT': localePtPT,
  ro: localeRo,
  ru: localeRu,
  uk: localeUk,
  sv: localeSv,
  tr: localeTr,
  vi: localeVi,
  'zh-CN': localeZhCN,
  'zh-TW': localeZhTW
})

angular
  .module('ggs.locale')
  .factory('localeNumberInternal', localeNumberInternalProvider)

function localeNumberInternalProvider(debugObj) {
  let numeralLocale = DEFAULT_LOCALE
  const threshold = 10000

  return debugObj('localeNumberInternal', StrictObj(debugFields({
    shortNumber,
    changeLocale
  }, {
    _numeralLocale: () => numeralLocale
  })))

  function changeLocale(appLocale) {
    numeralLocale = LOCALES[appLocale]
  }

  function shortNumber(num) {
    if (num < threshold) {
      return intcomma(num, numeralLocale)
    } else {
      return intabbr(num, numeralLocale)
    }
  }
}
